import axios from "../axios";

export const getTicketTypes = async () => {
  return axios.get("/api/MetaData/tickettypes");
};

export const getSeverityTypes = async () => {
  return axios.get("/api/MetaData/severitytypes");
};
